import React, { useEffect, useState } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import { FormValidate } from "../../../components/formValidate";
import { membership_add } from "../admin.api";
import "./view.css";
import CommonForm from "../../../components/commonform/commonForm";
let required = ["organization_name", "logo"];
export default function AddMembership(props) {
  const [formData, setFormData] = useState({
    member: true,
    head: false,
    governing_member: true,
    council_number: false,
  });
  let fiveYearsAgo = new Date();
  fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5, 0, 1);
  const today = new Date();
  const fiveYearsAfter = new Date(today.getFullYear() + 5, 11, 31);
  const endOfYear = new Date(today.getFullYear(), 11, 31);

  const [snackMessage, setSnackMessage] = useState("");
  const [fileChanged, setFileChanged] = useState(false);
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [err, setErr] = useState(false);
  const [keyvalue, setKeyValue] = useState(1);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let data = formData;
    data = { ...data, [name]: value };
    setFormData(data);
  };

  const handlePhotoFileChange = (e) => {
    setIsActive(true);
    try {
      let flag = false;

      let type = e.target.files[0].name.split(".").pop();

      if (type === "png" || type === "jpeg" || type === "jpg") {
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;

          image.onload = function () {
            var height = this.height;
            var width = this.width;

            if (height === 400 || width === 400) {
              flag = true;
            }
          };
        };
        setTimeout(() => {
          if (flag) {
            setFileChanged(true);
            setFormData({
              ...formData,
              [e.target.name]: e.target.files[0],
            });
            setIsActive(false);
          } else {
            setSnackMessage("Incorrect image dimension");
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
          }
        }, 2000);
      } else {
        setSnackMessage("File should be in .jpg / .jpeg / .png format");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      }
    } catch {
      setIsActive(false);

    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = FormValidate(formData, required);
    setIsActive(true);
    if (Object.keys(errors).length === 0) {
      const form = new FormData();
      form.append("organization_name", formData?.organization_name);
      if (formData?.membership_category) {
        form.append("membership_category", formData?.membership_category);
      }
      form.append("logo", formData.logo);
      if (formData?.from_date) {
        const [day, month, year] = formData?.from_date.split("-");
        form.from_date = `${year}-${month}-${day}`;
        form.append("from_date", form?.from_date);
      }
      if (formData?.to_date) {
        const [day1, month1, year1] = formData?.to_date.split("-");
        form.to_date = `${year1}-${month1}-${day1}`;
        form.append("to_date", form?.to_date);
      }

      membership_add(form)
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
          setIsActive(false);
        })
        .catch((error) => {
          setSnackMessage(error.message);
          setIsSnackError(true);
          setSnackOpen(true);
          setIsActive(false);
        });
    } else {
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/membership");
    }
  };
  const handleDatePickerChange = (e, name) => {
    let date = e.value;
    const dateRegex = /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/;
    if (dateRegex.test(date)) {
      setErr(false);
    } else {
      setErr(true);
    }
    setFormData({ ...formData, [name]: date });
    setKeyValue(keyvalue + 1);
  };

  return (
    <div className="add-per">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Add Membership</b>
        </h6>
        <hr />
        <div className="row">
          <div className="col-12">
            <TextField
              fullwidth
              label="Name of Organization"
              value={formData?.organization_name ?? ""}
              // maxLength={30}
              onChange={(e) => handleChange(e)}
              name="organization_name"
              id="organization_name"
              aria-describedby="emailHelp"
              // multiline
              required
            />
          </div>
          <div className="col-12">
            <TextField
              fullwidth
              label="Membership Category"
              // maxLength={30}
              value={formData?.membership_category ?? ""}
              onChange={(e) => handleChange(e)}
              name="membership_category"
              id="membership_category"
              // multiline
              aria-describedby="emailHelp"
              // required
            />
          </div>
          <div className="col-12">
            <CommonForm
              fieldType="date"
              label={`Date From `}
              // required
              name="from_date"
              minDate={new Date(fiveYearsAgo)}
              maxDate={endOfYear}
              value={formData?.from_date ?? ""}
              onChange={(e) => {
                handleDatePickerChange(e, "from_date");
              }}
              {...props}
            />
          </div>
          <div className="col-12">
            <CommonForm
              fieldType="date"
              label={`Date To `}
              // required
              name="to_date"
              minDate={today}
              maxDate={fiveYearsAfter}
              value={formData?.to_date ?? ""}
              onChange={(e) => {
                handleDatePickerChange(e, "to_date");
              }}
              {...props}
            />
            {err && (
              <div className="file-up-helper mt-1">
                Please select a valid date
              </div>
            )}
          </div>

          <div className="col-12">
            <TextField
              label="Logo"
              id="formFileSm"
              onChange={(e) => handlePhotoFileChange(e)}
              accept=".jpg,.jpeg,.png"
              required
              name="logo"
              type="file"
            />
            <small className="pers">
              *Upload only .jpg , .jpeg , .png format and Size should be less
              than 1MB of width: 400 Height: 400
            </small>
          </div>
          <div className="col-12">
            <center>
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={(e) => handleSubmit(e)}
              >
                Submit for Acceptance
              </button>
            </center>
          </div>
          {/* ---------------- */}
        </div>
      </div>
    </div>
  );
}
// this is it
